import {Component} from 'react';
import {Contest, Footer, Hero, Partner, Preloader} from "../../components";

import artPic from '../../resources/pics/art.png';
import blankPic from '../../resources/pics/blank.jpg';

import closeIcon from '../../resources/icons/close.svg';
import closeNewIcon from '../../resources/icons/new-close.svg';
import partnerIcon from '../../resources/icons/partner.svg';
import playIcon from '../../resources/icons/play.svg';
import tooltipIcon from '../../resources/icons/tooltip.svg';
import tooltipCloseIcon from '../../resources/icons/tooltip-close.svg';
import logoIcon from '../../resources/icons/logo.svg';

import footerBg from '../../resources/bg/footer.png';
import heroBg from '../../resources/bg/hero.png';
import partnerBg from '../../resources/bg/partner.png';
import rulesBg from '../../resources/bg/rules.png';
import modalBg from '../../resources/bg/modal.png';

import botBgMobile from '../../resources/bg/mobile/bot.png';
import footerBgMobile from '../../resources/bg/mobile/footer.png';
import heroBgMobile from '../../resources/bg/mobile/hero.png';
import partnerBgMobile from '../../resources/bg/mobile/partner.png';
import rulesBgMobile from '../../resources/bg/mobile/rules.png';
import modalBgMobile from '../../resources/bg/mobile/modal.png';

import video1 from '../../resources/video/1.jpg';
import video2 from '../../resources/video/2.jpg';
import video3 from '../../resources/video/3.jpg';


export class App extends Component {
    state = {
        loading: true
    }

    componentDidMount() {
        let images = [artPic, blankPic, closeIcon, closeNewIcon, partnerIcon, playIcon, tooltipIcon, tooltipCloseIcon, logoIcon, footerBg, heroBg, partnerBg, rulesBg, modalBg, botBgMobile, footerBgMobile, heroBgMobile, partnerBgMobile, rulesBgMobile, modalBgMobile, video1, video2, video3];
        let promises = [];

        images.forEach(image => {
            promises.push(new Promise((resolve, reject) => {
                const newImage = new Image();

                newImage.addEventListener("load", function () {
                    resolve();
                });

                newImage.src = image;
                window[image] = newImage;
            }));
        });

        Promise.all(promises).then(() => {
            this.setState(({loading}) => ({
                loading: !loading
            }));
        });
    }

    render() {
        const currentContent = <>
            <Hero/>
            <Partner/>
            <Contest/>
            <Footer/>
        </>

        return (
            <div className="wrapper">
                {this.state.loading ? <Preloader/> : currentContent}
            </div>
        );
    }
}